var _defs, _path, _rect, _path2, _path3, _path4, _path5, _polygon, _path6, _style;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLoaderWhite(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "vodaheart",
    "data-name": "Livello 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 146.746 234.292",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n                .cls-1,.cls-2{fill:#fff;}\n            .cls-1,.cls-3,.cls-5,.cls-6{stroke:#fff;stroke-linecap:round;stroke-linejoin:round;}\n            .cls-1{stroke-width:4.432px;}\n            .cls-3,.cls-5,.cls-6{fill:none;}\n            .cls-3{stroke-width:4.473px;}\n            .cls-4{fill:#fff;}\n            .cls-5{stroke-width:2.863px;}\n            .cls-6{stroke-width:5px;}\n            .cls-7{fill:#e30613;}\n        "))), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "heart") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M292.16,384.222c-9.453,16.1-26.96,28.5-28.771,29.766a.243.243,0,0,1-.3-.01,193.95,193.95,0,0,1-26.5-27.524c-13.1-16.928-6.195-33.776,5.188-36.445,14.355-3.365,20.014,5.4,21.427,7.6,1.638-2.847,7.532-10.658,21-7.838C294.568,351.941,302.924,365.89,292.16,384.222Z",
    transform: "translate(-229.467 -283.693)"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    className: "cls-7 heartcover",
    y: 64.6,
    width: 67.72,
    height: 66.61
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M271.488,476.792",
    transform: "translate(-229.467 -283.693)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M265.463,367.117",
    transform: "translate(-229.467 -283.693)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M263.159,344.331",
    transform: "translate(-229.467 -283.693)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M263.159,344.331a93.672,93.672,0,0,1,25.259-33.653c17.955-14.869,42.554-24.41,64.863-24.485a32.366,32.366,0,0,1,6.672.565l.034.008c.443.1.52.395.03.494l-.04.01c-19.026,4.456-34.012,22.334-33.945,42.57a11.225,11.225,0,0,0,.131,1.747c32.641,7.95,47.459,27.645,47.55,54.9s-21.425,57.11-57.786,57.231c-17.4.058-35.214-8.691-46.908-24.182",
    transform: "translate(-229.467 -283.693)"
  })), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "49.218 65.475 49.218 65.475 49.218 65.475 49.218 65.475"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M284.208,349.772a26.928,26.928,0,0,0-5.523-.6v5a22.129,22.129,0,0,1,4.5.5,11.239,11.239,0,0,1,7.717,6.666c2.468,5.573,1.383,12.8-3.053,20.359-6.976,11.884-18.767,21.742-24.362,26.021a189.387,189.387,0,0,1-22.942-24.319c-5.518-7.128-7.4-14.822-5.173-21.111,1.365-3.849,4.187-6.617,7.548-7.4a22.242,22.242,0,0,1,5.027-.628A12.161,12.161,0,0,1,259,360.311l4.441,6.916,4.1-7.123c1.027-1.784,4.17-5.935,11.146-5.936v-5h0c-9.607,0-14.085,6.019-15.479,8.442a17.223,17.223,0,0,0-15.259-8.361,27.032,27.032,0,0,0-6.168.76c-11.383,2.669-18.293,19.517-5.188,36.445a193.95,193.95,0,0,0,26.5,27.524.241.241,0,0,0,.154.056.253.253,0,0,0,.144-.046c1.811-1.262,19.318-13.663,28.771-29.766C302.924,365.89,294.568,351.941,284.208,349.772Z",
    transform: "translate(-229.467 -283.693)"
  })), _style || (_style = /*#__PURE__*/React.createElement("style", null, "\n        #vodaheart { width: 100px }\n        #vodaheart .heartcover { animation: pulse 2s infinite; }\n\n        @keyframes pulse {\n            0% { transform: translate3d(0,0,0); }\n            100% {transform: translate3d(0,-70px,0); }\n        }\n    ")));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLoaderWhite);
export default __webpack_public_path__ + "static/media/loaderWhite.fab569f9a13a3e4f81fe528ba78e1068.svg";
export { ForwardRef as ReactComponent };